import * as Yup from 'yup';
import { getDefaultItemId } from 'src/components/formik-utils';

export const validationSchema = () => {
  let schema = Yup.object();
  schema = schema.shape({
    isVerified: Yup.boolean(),

    referenceField: Yup.string()
      .transform((val) => (val || '').trim())
      .nullable()
      .when('isVerified', {
        is: false,
        then: (schema) => schema.required('Mã tham chiếu phải có'),
        otherwise: (schema) => schema.nullable(),
      }),
    smsField: Yup.string()
      .transform((val) => (val || '').trim())
      .nullable()
      .when('isVerified', {
        is: true,
        then: (schema) => schema.required('Nội dung tin nhắn phải có'),
        otherwise: (schema) => schema.nullable(),
      }),
    });
  return schema;
};

export const handleSubmitted = async (values, item, apiUpdateBillNo, apiSendTicket, apiUnsendTicket) => { 
  const myId = getDefaultItemId(item);
  if (myId === 0) return;

  if (values.isVerified) {
    const json = {
      moduleType: 1,
      userId: item.contact?.id,
      reason: values.smsField,
      sourceId: myId
    };
    await apiSendTicket(json);
  } else {
    const ticketId = item.ticket?.id;
    if(ticketId > 0){
      const json = {
        moduleType: 1,
        userId: item.contact?.id,
        ticketId: ticketId,
      };
      await apiUnsendTicket(json);
      // TODO remove billno
    }else{
      // Please convert for remove space
      const billNo = values.referenceField.replace(/\s+/g, '');
      await apiUpdateBillNo({fuelId: myId, billNo: billNo});
    }
  }
};
